<div
  class="border border-dashed border-outline dark:border-outline-darkmode self-stretch p-6 rounded-lg inline-flex flex-col justify-center items-center gap-3 w-full"
>
  <div class="self-stretch flex flex-col justify-start items-center gap-1">
    <div
      class="self-stretch text-center justify-start text-on-surface dark:text-on-surface-darkmode text-sm font-semibold leading-5"
    >
      {{ 'cockpit.energyInterfaces.page.noLocationsTitle' | transloco }}
    </div>
    <div
      class="self-stretch text-center justify-start text-on-surface-subtle dark:text-on-surface-subtle-darkmode text-sm font-normal leading-5 max-w-xs m-auto"
    >
      {{ 'cockpit.energyInterfaces.page.noLocationsSubtitle' | transloco }}
    </div>
  </div>
  <div class="flex justify-start items-center gap-3">
    <ui-button mode="outlined" [routerLink]="['/organizations', organizationId(), 'locations']">
      {{ 'cockpit.energyInterfaces.page.navigateToLocations' | transloco }}
      <ng-icon slot="end" name="heroArrowRight" size="20" class="!block" />
    </ui-button>
  </div>
</div>
